import { useSyncExternalStore } from 'react';

// Who is signed in on this host page (game-server teacher.ts): the teacher password's account (admin), or a teacher
// it invited. An invited teacher has only the classes they made: no boards.json classes, no courses, no Private class,
// no after-school switch. Kept apart from client.ts and hostGames.ts so both can read it.
export interface TeacherMe {
  id: string;
  name: string;
  admin: boolean;
}
const ADMIN_ME: TeacherMe = { id: 'teacher', name: '先生', admin: true };
let me: TeacherMe = ADMIN_ME;
const heard = new Set<() => void>();
const listen = (f: () => void) => {
  heard.add(f);
  return () => void heard.delete(f);
};
// m left out: a server from before teacher accounts, so the teacher password's
export function setTeacherMe(m: TeacherMe | undefined) {
  const next = m && typeof m.id === 'string' ? { id: m.id, name: String(m.name ?? '先生'), admin: !!m.admin } : ADMIN_ME;
  if (next.id === me.id && next.name === me.name && next.admin === me.admin) return;
  me = next;
  heard.forEach((f) => f());
}
export const teacherMe = () => me;
export const useTeacherMe = () => useSyncExternalStore(listen, () => me);
// A key for what this laptop keeps per teacher (the bank cache, the tray draft, the usual class): the teacher
// password's account keeps the keys it always had; an invited teacher's carry their id, so a shared laptop never shows
// one teacher another's.
export const mineKey = (base: string) => (me.admin ? base : `${base}:${me.id}`);
